// extracted by mini-css-extract-plugin
export default {"Sound":"Sound_Sound__ZhF0h"};